import { render } from "./PatientDetailsCard.vue?vue&type=template&id=91a4f150&ts=true"
import script from "./PatientDetailsCard.vue?vue&type=script&lang=ts"
export * from "./PatientDetailsCard.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__